import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { PROMOTION_PROPTYPES } from 'propTypes';
import { CANCEL_GROUP_ORDER_CONFIRMATION_MODAL } from 'constants/cart';
import CartInfoWithNoTax from 'bento-ordering/cart/components/CartInfoWithNoTax';
import ShowAllGuestButton from 'bento-ordering/cart/components/ShowAllGuestButton';
import GroupOrderGuestCartCTAs from 'bento-ordering/group_ordering/components/GroupOrderGuestCartCTAs';
import CancelGroupOrderCTA from 'bento-ordering/group_ordering/components/CancelGroupOrderCTA';
import {
  useIsGroupOrderGuestDiner,
  useIsGroupOrderAdminDiner
} from 'bento-ordering/group_ordering/hooks/index';
import { useHasInvestorDayFeatureFlag } from 'bento-ordering/utils/featureFlags/hasInvestorDayFeatureFlag';

const CartInfoManager = ({
  toggleIsOpen,
  fulfillmentMethod,
  total_owed,
  subtotal,
  digitalGiftCardAmountApplied,
  tipAmount,
  promotion,
  renderShowAllGuestsButton,
  dinersCount,
  hideShowAllGuestsButton,
  onlineOrderingServiceFee
}) => {
  const isGroupOrderGuestDiner = useIsGroupOrderGuestDiner();
  const isGroupOrderAdminDiner = useIsGroupOrderAdminDiner();
  const hasInvestorDayFeature = useHasInvestorDayFeatureFlag();

  const ShowAllGuestButtonComponent = renderShowAllGuestsButton ? (
    <ShowAllGuestButton
      dinersCount={dinersCount}
      handleOnClick={hideShowAllGuestsButton}
    />
  ) : null;

  const CancelGroupOrderCTAComponent = isGroupOrderAdminDiner ? (
    <Box>
      <CancelGroupOrderCTA
        handleOnClick={() =>
          toggleIsOpen(CANCEL_GROUP_ORDER_CONFIRMATION_MODAL)
        }
      />
    </Box>
  ) : null;

  if (isGroupOrderGuestDiner) {
    return <GroupOrderGuestCartCTAs toggleIsOpen={toggleIsOpen} />;
  } else if (hasInvestorDayFeature) {
    return null;
  } else {
    return (
      <>
        {ShowAllGuestButtonComponent}
        <CartInfoWithNoTax
          subtotal={subtotal}
          toggleIsOpen={toggleIsOpen}
          onlineOrderingServiceFee={onlineOrderingServiceFee}
        />
        {CancelGroupOrderCTAComponent}
      </>
    );
  }
};

CartInfoManager.propTypes = {
  toggleIsOpen: PropTypes.func,
  fulfillmentMethod: PropTypes.string,
  total_owed: PropTypes.number.isRequired,
  subtotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  digitalGiftCardAmountApplied: PropTypes.number.isRequired,
  tipAmount: PropTypes.string.isRequired,
  promotion: PROMOTION_PROPTYPES,
  renderShowAllGuestsButton: PropTypes.bool.isRequired,
  dinersCount: PropTypes.number.isRequired,
  hideShowAllGuestsButton: PropTypes.func.isRequired,
  onlineOrderingServiceFee: PropTypes.number.isRequired
};

export default CartInfoManager;
